module.exports = __webpack_public_path__ + "static/media/spain.2cd21a1b.svg";